import { Link } from 'react-router-dom';
import type { News } from '@/types';

export default function NewsRow({ news, showCover = false }: { news: News; showCover?: boolean }) {
  return (
    <Link
      to={`/news/detail/${news.id}`}
      className="block group cursor-pointer px-3 md:px-4 py-3 border-b border-background-200/70 last:border-b-0 hover:bg-accent-50/70 transition-colors"
    >
      <div className="flex gap-3">
        {showCover && (
          <div className="w-20 h-14 md:w-24 md:h-16 rounded-md overflow-hidden shrink-0 bg-background-200">
            <img src={news.cover} alt={news.title} className="w-full h-full object-cover object-top" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-800 whitespace-nowrap">{news.category}</span>
            <span className="text-[10px] md:text-xs text-foreground-500 whitespace-nowrap">{news.date}</span>
          </div>
          <h3 className="text-sm md:text-[15px] font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
            {news.title}
          </h3>
          {!showCover && (
            <p className="mt-1 text-xs md:text-sm text-foreground-500 line-clamp-2">{news.summary}</p>
          )}
        </div>
      </div>
    </Link>
  );
}